"use strict";

/** Display label for menu-setup dropdowns (appMenuId may be empty on hybrid tenants). */
export const getMenuSelectLabel = (menu, language = "en") => {
  const appMenuId = menu?.appMenuId?.trim();
  if (appMenuId) return appMenuId;

  const nameEn = menu?.menuNameEn?.trim();
  const nameAr = menu?.menuNameAr?.trim();
  if (language === "sa" || language === "ar") {
    return nameAr || nameEn || "Unnamed Menu";
  }
  return nameEn || nameAr || "Unnamed Menu";
};

const normalizeCountryCode = (value) =>
  value == null || value === "" ? "" : String(value).trim().toUpperCase();

const resolveBrandId = (brand) => {
  if (brand == null) return "";
  if (typeof brand === "object") {
    return String(brand.value ?? brand._id ?? brand.id ?? "");
  }
  return String(brand);
};

/** Country select value may be { countryCode } (branch) or { value } (category filters). */
export const resolveCountryCodeFromSelection = (countrySelection) => {
  if (!countrySelection) return "";
  if (countrySelection.countryCode) {
    return normalizeCountryCode(countrySelection.countryCode);
  }
  return normalizeCountryCode(countrySelection.value);
};

export const menuMatchesBrandAndCountry = (menu, brand, countrySelection) => {
  const brandId = resolveBrandId(brand);
  const countryCode = resolveCountryCodeFromSelection(countrySelection);
  if (!brandId || !countryCode) return false;

  const menuBrandId = String(menu?.brand?._id ?? menu?.brand ?? "");
  if (menuBrandId !== brandId) return false;

  const codes = Array.isArray(menu?.countryCode) ? menu.countryCode : [];
  return codes.some(
    (code) => normalizeCountryCode(code) === countryCode
  );
};

export const filterMenusByBrandAndCountry = (menus, brand, countrySelection) =>
  (menus ?? []).filter((menu) =>
    menuMatchesBrandAndCountry(menu, brand, countrySelection)
  );

export const mapMenusToSelectOptions = (menus, language = "en") =>
  (menus ?? []).map((item) => ({
    label: getMenuSelectLabel(item, language),
    value: item._id,
  }));

export const buildFilteredMenuSelectOptions = (
  menus,
  brand,
  countrySelection,
  language = "en"
) =>
  filterMenusByBrandAndCountry(menus, brand, countrySelection).map((item) => ({
    label: getMenuSelectLabel(item, language),
    value: item._id,
  }));

export const buildMenuFetchParams = (brand, countrySelection) => {
  const brandId = resolveBrandId(brand);
  const countryCode = resolveCountryCodeFromSelection(countrySelection);
  if (!brandId || !countryCode) return null;
  return { brandId, countryCode };
};
